import approvalStatuses from "./constants/approvalStatuses";

export default function isApproved(data) {
	return data.approved || data.approval?.status === approvalStatuses.APPROVED;
}
